import styled from "styled-components";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  isValidated?: boolean;
}

const Input = styled.input<Props>`
  width: 100%;
  border-radius: 2px;
  padding: 11px 15px;
  box-sizing: border-box;
  border: 1px solid #cacaca;
  color: ${COLORS.BLACK};
  font-size: ${calcRem(14)};
  height: 37px;

  &::placeholder {
    color: #abb5c5;
  }
  &:disabled {
    background-color: ${({ theme }) => theme.COLORS.DISABLED};
    border-color: ${({ theme }) => theme.COLORS.DISABLED_BORDER};
    color: ${({ theme }) =>
      theme.value === "light"
        ? `${theme.COLORS.WHITE}60`
        : theme.COLORS.LIGHTGRAY};
    cursor: not-allowed;
  }

  ${({ isValidated }) =>
    isValidated &&
    `
      border: 1px solid ${COLORS.VALIDATERED};
      background-color: #FFD5D5;
  `}
`;

export const NumberInput = (props: Props) => {
  return (
    <Input
      {...props}
      type="text"
      inputMode="numeric"
      pattern="\d*"
      onChange={(e) => {
        if (e.target.value !== "" && isNaN(Number(e.target.value))) {
          e.preventDefault();
          return;
        }
        props.onChange?.(e);
      }}
      autoComplete="off"
      data-testid="atoms-input-atoms-input-is-na-n"
    />
  );
};

export default Input;
